$(document).ready(function () {
  $(".Review-Carousel").owlCarousel({
    loop: false,
    rewind: true,
    margin: 15,
    nav: true,
    dots: false,
    autoplay: true,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });
});
